module.exports = __webpack_public_path__ + "assets/img/33_1462_big.96880707.jpg";